//* Vue Router
import type { RouteRecordRaw } from "vue-router";

export default [
    {
        name: "UserLayout",
        path: "/user",
        meta: { permission: true },
        component: () => import("@/views/user/components/layout/index.vue"),
        children: [
            {
                name: "UserInfo",
                path: "",
                component: () => import("@/views/user/views/info/index.vue"),
            },
            {
                name: "UserAgent",
                path: "agent",
                component: () => import("@/views/user/views/agent/index.vue"),
            },
            {
                name: "UserFeedback",
                path: "feedback",
                component: () => import("@/views/user/views/feedback/index.vue"),
            },
            {
                name: "UserFavorites",
                path: "favorites",
                component: () => import("@/views/user/views/favorites/index.vue"),
            },
            {
                name: "UserRecentActivity",
                path: "history",
                component: () => import("@/views/user/views/history/index.vue"),
            },
        ],
    },
] as RouteRecordRaw[];
